import { createSlice, PayloadAction, createAction } from '@reduxjs/toolkit';
import { GetRoomWithSchedulesV2, GetRoomSchedulesV2 } from 'api/room';
import { AreaV2, RoomPageV2, RoomSchedule, RoomV2, RoomWithOrder } from 'type/room';

// 模型定义, 该用户相关的操作和数据
type InitialState = {
  area: AreaV2[];
  roomWithOrder: RoomWithOrder[]; /** 废弃 */
  /** 会议室加载态 */
  loading: boolean; /** 废弃 */
  /** 分页是否加载全部 */
  noMore: boolean /** 废弃 */
  searching: boolean;
  pageSize: number; /** 废弃 */
  currentPage: number; /** 废弃 */
  room: RoomPageV2; /** 废弃 */
  orders: RoomSchedule[]; /** 废弃 */
  roomDetail: RoomV2 | null;
};

const initialState = {
  area: [],
  roomWithOrder: [],
  loading: false,
  noMore: false,
  searching: false,
  pageSize: 100,
  currentPage: 1,
  room: {
    pageNo: 1,
    pageSize: 30,
    total: 0,
    data: []
  },
  orders: [],
  roomDetail: null
} as InitialState;

const room = createSlice({
  name: 'room',
  initialState: initialState,
  reducers: {
    setArea (state, action: PayloadAction<AreaV2[]>) {
      state.area = action.payload;
    },
    setRoomList (state, action: PayloadAction<RoomPageV2>) {
      state.room = action.payload;
      state.noMore = action.payload.pageNo * action.payload.pageSize >= action.payload.total;
    },
    setRoomLoadingPending (state) {
      state.loading = true;
    },
    setRoomLoadingFulfilled (state) {
      state.loading = false;
    },
    setRoomLoadingRejected (state) {
      state.loading = false;
    },
    setRoomSearching (state, action: PayloadAction<boolean>) {
      state.searching = action.payload;
    },
    setOrder (state, action: PayloadAction<RoomSchedule[]>) {
      const orders = action.payload;
      state.orders = orders;
    },
    addOrder(state, action: PayloadAction<RoomSchedule>) {
      const order = action.payload;
      state.orders = [...state.orders, order];
    },
    setCurrentPage (state, action: PayloadAction<number>) {
      if (!action.payload) return;
      state.currentPage = action.payload;
    },
    setRoomDetail (state, aciton: PayloadAction<RoomV2 | null>) {
      state.roomDetail = aciton.payload;
    }
  }
});

export default room.reducer;

export const getAreas = createAction('room/getAreas');
export const getRoomWithOrder = createAction<{ params: GetRoomWithSchedulesV2; loadMore?: boolean; onSuccess?:(rooms: RoomV2[]) => void }>('room/getRoomWithOrder');
export const signRoom = createAction<string>('room/sign');
export const getOrder = createAction<{ params: GetRoomSchedulesV2, loadMore?: boolean }>('room/getOrder');
export const getRoomDetail = createAction<string>('room/getRoomDetail');

export const {
  setArea,
  setRoomLoadingPending,
  setRoomLoadingFulfilled,
  setRoomLoadingRejected,
  setRoomSearching,
  setOrder,
  setCurrentPage,
  setRoomList,
  setRoomDetail
} = room.actions;
